import { get } from 'lodash'
import { resizeThumbnail } from '@/common/image.filter'
import { getTitle, isApp } from '@/common/util/common'
import { getEventListByType } from '@/common/util/event.util'
import { EventBus } from '@/components/eventbus/EventBus'
import { ON_CLICK } from '@/common/event.const'
import { parseUrl } from 'query-string'
import { PATH_NAME_APOLLO_PLAYER, PATH_NAME_PLAYER } from '@/common/router.const'
import { STORAGE_CONTENT_FROM_SEARCH } from '@/common/resources/const'

export default {
  props: {
    cellInfo: {
      type: Object
    },
    thumbnailInfo: {
      type: Object
    }
  },
  data () {
    return {
      isImageLoaded: false
    }
  },
  computed: {
    getThumbnailImg () {
      return resizeThumbnail(get(this.cellInfo, 'thumbnail', ''), this.thumbnailInfo).replace('w320', 'w208').replace('h180', 'h296')
    },
    altTitle () {
      return getTitle(this.cellInfo)
    },
    isProgress () {
      return get(this.cellInfo, 'progress', '') !== ''
    },
    progress () {
      return get(this.cellInfo, 'progress', '')
    },
    isThumbnail () {
      return get(this.cellInfo, 'thumbnail', '') !== ''
    },
    eventList () {
      return get(this.cellInfo, 'event_list', '')
    },
    zzim () {
      return get(this.cellInfo, 'iszzim', 'n').toLowerCase()
    },
    topTagList () {
      return get(this.cellInfo, 'top_taglist', []).concat(get(this.cellInfo, 'bottom_taglist', []))
    },
    brandTagList () {
      return get(this.cellInfo, 'brand_taglist', [])
    },
    updateTagList () {
      return get(this.cellInfo, 'update_taglist', [])
    },
    alt () {
      return get(this.cellInfo, 'alt', '')
    },
    titleList () {
      return get(this.cellInfo, 'title_list', [])
    },
    altClassName () {
      let className = 'alt-title'
      if (this.isImageLoaded && this.isThumbnail) {
        className = `${className} fade-out`
      }
      return className
    }
  },
  methods: {
    router (pathInfo) {
      if (sessionStorage.getItem(STORAGE_CONTENT_FROM_SEARCH) === 'y') {
        this.$router.replace(pathInfo)
      } else {
        this.$router.push(pathInfo)
      }
    },
    moveToPlayer (navigationUrl) {
      let { url, query } = parseUrl(navigationUrl)
      let section = url.split('/').pop()
      if (section === 'list') {
        this.$router.push({
          name: 'channelclip',
          params: {
            uiCode: query.uicode
          }
        })
      } else {
        let pathName = this.$route.name === PATH_NAME_APOLLO_PLAYER ? PATH_NAME_APOLLO_PLAYER : PATH_NAME_PLAYER
        this.$router.push({
          name: pathName,
          params: {
            section
          },
          query: query
        })
      }
    },
    selectCell () {
      const { onNavigationEvent, onClickEvent } = getEventListByType(get(this.cellInfo, 'event_list', []))
      if (onClickEvent) {
        EventBus.$emit(ON_CLICK, onClickEvent)
      }
      let navigationUrl = get(onNavigationEvent, 'url', '').replace('.html', '')
      if (isApp()) {
        location.href = `captvpooq:/${navigationUrl.replace('captvpooq:/', '')}`
      } else {
        this.moveToPlayer(navigationUrl)
      }
    },
    onImageLoad () {
      this.isImageLoaded = true
    }
  }
}
